import React from "react";
import { Route, Redirect } from "react-router-dom";
import { getCurrentUser } from "../services/http/authService";

const ProtectedSuperuserRoute = ({ path, component: Component, render, ...rest }) => {

  const isSuperuser = () => {
    const user = getCurrentUser();
    if (!user || user.superuser == false) return false;
    return true;
  }

  return (
    <Route
      path={path}
      {...rest}
      render={props => {
        if (!isSuperuser())
          return (
            <Redirect
              to={{ pathname: "/sign-in", state: { from: props.location } }}
            />
          );
        return Component ? <Component {...props} /> : render(props);
      }}
    />
  );
};

export default ProtectedSuperuserRoute;